export default __webpack_public_path__ + "static/media/cardCarbs.e7d1bd10.svg";